import React, { Component, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility from "../../../../utility/Utility";
import { deepClone } from "../../../../utility/Utility"
import { DKLabel, DKButton, DKSpinner,DKInput,INPUT_TYPE,INPUT_VIEW_DIRECTION, showLoader, removeLoader,DKListPicker,DKCalendar,TOAST_TYPE, showToast} from "deskera-ui-library";
import DataGridHolderPayroll from "../../../common/DataGridHolderPayroll";
import { parseColumnConfig, PayrollLiabilityColumnConfig, SyncRevertJEBooksIntegrationColumnConfig } from "../../../configs/config";
import { fetchPayrollLiabilityReport, selectPayrollLiability, addColumnToPayrollLiabilityColumnConfig } from "../../../../Redux/Slices/PayrollLiabilityReportSlice";
import PayrollLiabilityService from "../../../../services/PayrollLiabilityReportService";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../../managers/TableManger";

const PayrollLiabilityGrid = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks
    
    const [payrollLiability, setPayrollLiability] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    
    //Store data selectors
    const dispatch = useDispatch();
    const payrollLiabilityData = useSelector(selectPayrollLiability);
    const columnConfig = useSelector(addColumnToPayrollLiabilityColumnConfig);
    const isActionEnabled = false;

    useEffect(() => {
        // RouteManager.setPresenter({ props });
        if(props&&props.filter) {
            showLoader();
        /* API Calls Start */
            loadLiabilityReport(props.filter);
            
            /* API Calls End */
            return () => {
                window.openSelectedLocation= () => {};
                setPayrollLiability(initialState)};
            }
        
    }, [props.generate])

    useEffect(() => {
        if (!Utility.isEmpty(payrollLiabilityData) && props.filter) {
            const { liabilities, pageable,totalPages,totalElements } = payrollLiabilityData;
            const rowData = PayrollLiabilityColumnConfig(liabilities);
            let reportColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PAYROLL_LIABILITY_REPORT))
            const passingData = {
                columnData: deepClone(reportColumn),
                rowData,
                filter: [],
                originalData: rowData
            };
            removeLoader();
            setPayrollLiability(passingData);
            setTotalPageCount(1);
            setCurrentPage(1);
            setTotalCount(liabilities?liabilities.length:0)
        }
    }, [payrollLiabilityData,props]);

    const loadLiabilityReport = async (config) => {
        try {
            // showLoader()
            PayrollLiabilityService.apiConfig = config;
            await dispatch(fetchPayrollLiabilityReport());
            // console.log(attendance)
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };
    const onDeleteContact = (data) => {
        const attendanceId = data[0].id;
        // ContactService.deleteContact(payrollId).then((res) => {
        //     showToast('Contact Deleted Successfully', TOAST_TYPE.WARNING);
        //     loadContacts({});
        // });
    };

    const onRowEdit = (data) => {
        // const contactList = contactsData['content'];
        // const contactId = data.rowData.id;
        // const contactData = contactList.filter(
        //     (contact) => contact.id === contactId
        // )[0];
        // if (contactData) {
        //     setEditableContact(contactData);
        //     setShowPopup(true);
        // }
    };
    const onSearch = (searchTerm) => {
        const config = {
            ...PayrollLiabilityService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm
        };
        loadLiabilityReport(config);
    };
    const newColumnAdded = (data) => {
        const columns = payrollLiability.columnData;
        columns.push(data);
        setPayrollLiability({ ...payrollLiability, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
        // if (queries.length === 0) {
        //     setContacts({
        //         ...contacts,
        //         rowData: contacts.originalData,
        //         filter: queries
        //     });
        // } else {
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedList,
        //         filter: queries
        //     });
        // }
    };

    const onRowAdd = (newRow) => {
        // if (newRow) {
        //     let updatedRowData = [...contacts.rowData];
        //     updatedRowData.unshift(newRow);
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedRowData,
        //         originalData: updatedRowData
        //     });
        // }
    };
    return(
        <>
            <div className="column parent-width flex-1 parent-height mt-l">
                <div className="column parent-width mb-s position-relative flex-1 parent-width">
                    <DataGridHolderPayroll
                        tableName={TABLES.PAYROLL_LIABILITY_REPORT}
                        displayTableName={" abc"}
                        allowColumnEdit={false}
                        onRowOpenBtnHidden={true}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        onRowDelete={onDeleteContact}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}


                        allowDataExport={false}
                        gridData={payrollLiability}
                        onSearch={onSearch}
                        onColumnAdd={newColumnAdded}
                        onFilter={onFilter}
                        filter={payrollLiability.filter}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            const config = {
                                ...PayrollLiabilityService.apiConfig,
                                page: requestedPageNumber - 1
                            };
                            loadLiabilityReport(config);
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={isActionEnabled}
                        isHeaderHidden={true}
                    />
                </div>
            </div>
        </>
    )
}
export default PayrollLiabilityGrid